<template>
  <sky-charts ref="chart"
              :queryCondition="condition"
              :config="chartConfig"
              legendPosition="bottom"
              :showTitle="false"
              :showShadow="false"
              :chartData="data"
              :extend="extend">
    <div slot="header"
         class="header">
      <div class="title">{{tabName}}{{selectName}}TOP10</div>
      <div class="select">
        <el-select v-model="selectVal"
                   placeholder="展示占比"
                   size="mini"
                   @change="change">
          <el-option v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
  </sky-charts>
</template>

<script>
import mixins from "./ga_mixins";
import { fbChartsRatioPie } from "@/common/dictionary.js";
import filters from "@/mixins/filters.js";
export default {
  name: "fb-series-pie",
  mixins: [mixins],
  components: {},
  props: {
    activeClass: String,
  },
  data () {
    let that = this;
    return {
      selectVal: "IMPRESSIONS",
      options: fbChartsRatioPie,
      selectName: "展示占比",
      selectTitle: '展示次数',
      tabName: "",
      tabItem: "",
      filterType: 'thousands',
      extend: {
        series: {
          type: 'pie',
          label: {
            formatter (val) {
              return that.data[val.dataIndex][`${that.activeClass}Name`]
            }
          }
        },
        tooltip: {
          formatter (val) {
            return that.setTooltipFormatter(val)
          }
        },
        legend: {
          bottom: 30,
          formatter (val) {
            let id = `${that.activeClass}Id`
            let name = `${that.activeClass}Name`
            let dataItem = that.data.find(item => item[id] === val)
            name = dataItem[name]

            var cArr = name.match(/[^\x00-\x80]/g);
            if (cArr) {
              if (cArr.length > 7 || name.length > 10) {
                name = name.slice(0, 6) + "...";
              }
            } else {
              if (name.length > 16) {
                name = name.slice(0, 13) + "...";
              }
            }
            var arr = [`{a|${name}}`].join("\n");
            return arr;
          },
          textStyle: {
            rich: {
              a: {
                width: 90,
                overflow: "hidden",
                lineHeight: 10
              }
            }
          }
        }
      },
      chartConfig: {
        height: "400px",
        type: "vePie",
        columns: [],
        rows: [],
        chartSettings: {
          radius: 80,
          offsetY: "40%",
        }
      },
      data: []
    };
  },
  watch: {
    condition: {
      handler (val) {
        this.data = val.data;
        this.tabName = val.tabName;
        this.tabItem = val.tabItem;
        this.chartConfig.columns = [`${this.activeClass}Id`, this.columnSwitch(this.selectVal)];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 改变排序字段
    change (val) {
      this.selectVal = val;
      this.switch(val);
      this.chartConfig.columns = [`${this.activeClass}Id`, this.columnSwitch(this.selectVal)];
      this.$emit('googlereportspie', val)
    },
    switch (val) {
      if (val) {
        let option = fbChartsRatioPie.find(item => item.value === val)
        this.selectName = option.label;
        this.selectTitle = option.sub;
        this.filterType = option.sub === '消耗' ? 'rmb' : 'thousands'
      }
    },
    columnSwitch (val) {
      switch (val) {
        case 'IMPRESSIONS':
          return 'impressions'
        case 'EFFECT':
          return 'effect'
        case 'COST':
          return 'exchangeRateCost'
      }
    },
    setTooltipFormatter (val) {
      let that = this
      let name = `${that.activeClass}Name`
      const fixedTooltip = [
        `${that.data[val.dataIndex][name]}</br>`,
        `${that.selectName}：${filters.filters.percent(val.percent / 100)}</br>`,
        `${that.selectTitle}：${filters.filters[that.filterType](val.value)}</br>`
      ]
      let dynamicTooltip = {
        campaign: [],
        adGroup: [`所属广告系列：${that.data[val.dataIndex].campaignName}</br>`],
        ad: [
          `所属广告系列：${that.data[val.dataIndex].campaignName}</br>`,
          `所属广告组：${that.data[val.dataIndex].adGroupName}</br>`
        ]
      }
      return fixedTooltip.concat(dynamicTooltip[that.activeClass]).join('');
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #000;
  .el-select {
    width: 130px;
    margin: 0 10px;
  }
}
</style>
